import { LobbyWidget } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { useTranslation } from '@bonanza-social/i18n';

function PromosLobbyWidget() {
  const [t] = useTranslation('promos');
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleClick = () => {
    navigation.navigate('Promos');
  };

  return (
    <LobbyWidget
      image="promos.lobbyWidgetIcon"
      label={t('widgetLabel')}
      onClick={handleClick}
    />
  );
}

export default memo(PromosLobbyWidget);
